import { Counterpart } from "./Entity";

export class CounterpartAccount {
  bank: string = null;
  account: string = null;
  branch: string = null;
  counterpartId: number = null;
  counterpartModel: Counterpart = null;
}
